import styled from '@emotion/styled'
import { css } from '@emotion/react'

import { Theme } from 'scripts/react-components/themes/Theme'

const bodyStyles = ({ theme }: Theme) => css`
  label: chatmodal_container-body;

  background: transparent;
  position: relative;
  display: flex;
  gap: 22px;
  flex: 1;
  height: 100vh;
  flex-direction: column;
  overflow-y: scroll;
  padding: 0 ${theme.spacings.kilo};
  scroll-snap-type: y proximity;
  scroll-padding: 10px;
`

export const Body = styled('div')(bodyStyles)
